<template>
  <v-app>
    <v-container>
      <headerApp></headerApp>
      <main>
        <div class="banner-top-1 px-mob" v-if="banners.length > 0 && banners.length >= bannersIsActive">
            <p>{{ banners[bannersIsActive] }}</p>
        </div>
        <PlanStep1 v-if="wizardMenu[0].isActive" />
        <PlanStep2 v-if="wizardMenu[1].isActive"/>
        <PlanStep3 v-if="wizardMenu[2].isActive"/>
        <PlanStep4 v-if="wizardMenu[3].isActive"/>
        <PlanStep5 v-if="wizardMenu[4].isActive"/>
        <PlanStep6 v-if="wizardMenu[5].isActive"/>
         <!-- <PlanStep7 v-if="wizardMenu[6].isActive"/> -->
      </main>
      <v-footer><footerApp></footerApp></v-footer> 
    </v-container>
  </v-app>
</template>

<script>

import  headerApp from '@/components/basic/headerApp.vue';
import footerApp from '@/components/basic/footerApp.vue';
import PlanStep1 from '@/components/wizard/PlanStep1.vue'
import PlanStep2 from '@/components/wizard/PlanStep2.vue'
import PlanStep3 from '@/components/wizard/PlanStep3.vue'
import PlanStep4 from '@/components/wizard/PlanStep4.vue'
import PlanStep5 from '@/components/wizard/PlanStep5.vue'
import PlanStep6 from '@/components/wizard/PlanStep6.vue'
// import PlanStep7 from '@/components/PlanStep7.vue'

export default {
  name: 'App',
  components: {
    headerApp,
    footerApp,
    PlanStep1,
    PlanStep2,
    PlanStep3,
    PlanStep4,
    PlanStep5,
    PlanStep6,
    // PlanStep7
  },
  computed: {
    wizardMenu() {
      return this.$store.getters.wizardMenu;
    },
    banners() {
      return this.$store.getters.banners;
    },
    bannersIsActive() {
      let page = 0;
      if ( this.banners ) {
        this.wizardMenu.forEach( (item, index) => {
          if ( item.isActive == true ) {
            page =  index + 1;
            
          }
        });
      }
     
      return page;
    }
  },
}
</script >

<style lang="stylus">
@import 'vuetify/dist/vuetify.min.css';
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap');

#order,
.v-container,
body {
  margin: 0!important;
  padding: 0!important;
  background: none;
  max-width: 100%!important;
  width: 100%;

  .breadcrumbs-app li.edit-order {
    opacity: .5;
    cursor: no-drop!important;
  }
}
.px-mob {
  @media screen and (max-width: 991px) {
    padding-left: 15px!important;
    padding-right: 15px!important;
  }
}

.bg-color {
  background: #F8F9FC;
}

v-header,
.v-footer {
  width: 100%;
    display: flex;
    justify-content: center;
}
.breadcrumbs-app {
  list-style: none 

  li {
      font-family: 'Manrope', sans-serif;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 19px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: -0.02em;
      color: #1D2433;
      border-bottom: 3px solid #1D2433;
      transition-duration: .4s;
      position: relative;

      @media screen and (max-width: 767px) {
        font-size: 14px;
      }

      a {
        text-decoration: none;
        transition-duration: .4s;

        &:hover {
          color: #50469a;
        }
      }
      &:after {
        position: absolute;
        content: '';
        bottom: -3px;
        left: 1px;
        height: 3px;
        background: #685BC7;
        border-radius: 20%;
        width: 0;        
      }

      &.active {
          color: #685BC7;
          border-bottom: 3px solid #E1E6EF;
          transition-duration: .4s;
          cursor: pointer;

          &:after {
            width: 100%;
          }

          &.last-child:after {
            width: 70%;
            transition-duration: .4s;
          }
          
          &:last-child.last-child:after {
            width: 100%;
          }
          
          &:nth-child(2).last-child {
            &:after {
              width: 35%;
            }

            &.step-two {
              &:after {
                width: 70%;
              }
            }
          }
      }
  }
}
button {
  cursor: pointer;
}

#order ul {
	margin-left: 0;
}
input[name=my_week_days] {	
	opacity: .6;
	cursor: not-allowed
}
#order button.btn-product-change:hover {
	background: #50469a; 
	color: #fff;
	border-color:#50469a;
}
#my_selected_plan_checkout_field,
#my_days_checkout_field {
	position: relative;
	cursor: not-allowed;
	z-index: 9999;
}
#my_selected_plan_checkout_field:after,
#my_days_checkout_field:after {
	width: 100%;
	height: 100%;
	position: absolute;
	content: '';
	top: 0;
	left: 0;
	z-index: 99;
	background-color: transparent;
}

</style>
